import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var sleekSupportiveIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.748 14c2.025.042 3.329.52 4.928 1.333L12 15.5c1.905.901 3.114 1.5 5.252 1.5 2.738 0 3.883-.33 6.02-2.42l.372.512c.272.44-.008 1.102-.538 1.578-1.332 1.2-3.116 1.83-5.854 1.83-2.16-.045-3.5-.586-5.252-1.5-1.905-.901-3.114-1.5-5.252-1.5-2.738 0-3.883.33-6.02 2.42l-.372-.512c-.272-.44.008-1.102.538-1.578C2.226 14.63 4.01 14 6.748 14Zm0-4c2.025.042 3.329.52 4.928 1.333L12 11.5c1.905.901 3.114 1.5 5.252 1.5 2.738 0 3.883-.33 6.02-2.42l.372.512c.272.44-.008 1.102-.538 1.578-1.332 1.2-3.116 1.83-5.854 1.83-2.16-.045-3.5-.586-5.252-1.5-1.905-.901-3.114-1.5-5.252-1.5-2.738 0-3.883.33-6.02 2.42l-.372-.512c-.272-.44.008-1.102.538-1.578C2.226 10.63 4.01 10 6.748 10Zm0-4c2.025.042 3.329.52 4.928 1.333L12 7.5c1.905.901 3.114 1.5 5.252 1.5 2.738 0 3.883-.33 6.02-2.42l.372.512c.272.44-.008 1.102-.538 1.578-1.332 1.2-3.116 1.83-5.854 1.83-2.16-.045-3.5-.586-5.252-1.5-1.905-.901-3.114-1.5-5.252-1.5-2.738 0-3.883.33-6.02 2.42l-.372-.512c-.272-.44.008-1.102.538-1.578C2.226 6.63 4.01 6 6.748 6Z",
  fill: "currentColor"
}));

export { sleekSupportiveIcon as default };
//# sourceMappingURL=sleekSupportiveIcon.js.map
